import { Component } from '@angular/core';
import CustomPrototype from '@core/classes/custom-prototype';
import { HasuraService } from '@core/services/hasura.service';
import { InjectorService } from '@core/services/injector.service';
import { TenantService } from '@core/services/tenant.service';
import { TranslateService } from '@ngx-translate/core';
import { SessionStorageService } from 'ngx-webstorage';
import { v4 as uuid } from 'uuid';





@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'itek-front-web';

  constructor(    
    public translateService: TranslateService,
    public tenantService: TenantService,    
    private sessionStorage: SessionStorageService,
    private hasuraService: HasuraService,
    private injectorService: InjectorService,
    
  ) {
      

    this.init();
  }

  init(){

    
    // create agentId
    /* ********************************************************************** */
    // verifica se já existe agentId e token. Se não existir cria, caso contrario não.
    if (!this.sessionStorage.retrieve('agentId') && !this.sessionStorage.retrieve('userToken')){
      const agentId = uuid();
      this.sessionStorage.store('agentId', agentId);
    }    
    /* ********************************************************************** */

    // translate service
    /* ********************************************************************** */
    const browserLang = this.translateService.getBrowserLang()?.toLowerCase() || 'pt';
    this.sessionStorage.store('agentLang', browserLang);
    this.translateService.addLangs(['pt', 'en', 'es']);
    this.translateService.setDefaultLang('en'); //info: se deichar direto pt, não muda para outras linguas. bug?
    this.translateService.use(browserLang.match(/pt|en|es/) ? browserLang: 'pt'); // the lang to use, if the lang isn't available, it will use the current loader to get them    
    /* ********************************************************************** */

    // Registra as extensions do prototype
    /* ********************************************************************** */
    CustomPrototype.register();
    /* ********************************************************************** */

    this.injectorService.init();
    this.tenantService.init(); // inicia o fluxo do sistema
    this.hasuraService.init();
    

  }

}
